import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Typography, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';

import { routes } from '../../../../pages';
import Separator from '../../../Separator';
import NotificationItem from '../../../../pages/Notifications/NotificationItem';
import './_notificationsBadge.scss';

const NotificationsBadge = ({ anchorEl, closeMenu }) => {
  const history = useHistory();
  const { data, getLoadnig } = useSelector(s => s.notifications);

  const renderNotifications = () => data.slice(0, 4).map((element, index) => <NotificationItem key={index} {...element} />);

  const emptyResults = () => (
    <Typography className="empty-results">
      Looks like you don&apos;t yet have notifications.
    </Typography>
  );

  return (
    <Menu
      id="notifications"
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={closeMenu}
      className="notifications-badge"
    >
      <div className="container">
        <Typography className="title">Notifications and activities</Typography>
        <Separator />
        <div className="list">
          {isEmpty(data) ? (!getLoadnig && emptyResults()) : renderNotifications()}
        </div>
        <Separator />
        <div className="see-all">
          <Button onClick={() => { closeMenu(); history.push(routes.notifications.root.link()); }}>See all</Button>
        </div>
      </div>
    </Menu>
  );
};

NotificationsBadge.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  anchorEl: PropTypes.any
};

export default NotificationsBadge;